import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Attach JWT token to every request if using custom auth.
// Azure SWA replaces both Authorization and X-Auth-Token headers with its
// own internal tokens, so we use a custom header name it won't intercept.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tripvibe_token');
  if (token) {
    config.headers['X-Tripvibe-Token'] = token;
  }
  return config;
});

// Clear stale token on 401 so Microsoft auth can take over
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('tripvibe_token');
    }
    return Promise.reject(err);
  }
);

// Trips
export const getTrips = () => api.get('/trips');
export const getTrip = (tripId) => api.get(`/trips/${tripId}`);
export const createTrip = (data) => api.post('/trips', data);
export const updateTrip = (tripId, data) => api.put(`/trips/${tripId}`, data);
export const deleteTrip = (tripId) => api.delete(`/trips/${tripId}`);
export const joinTrip = (shareCode) => api.post('/trips/join', { shareCode });
export const getTripMembers = (tripId) => api.get(`/trips/${tripId}/members`);

// Activities
export const addActivity = (tripId, data) => api.post(`/trips/${tripId}/activities`, data);
export const updateActivity = (tripId, activityId, data) =>
  api.put(`/trips/${tripId}/activities/${activityId}`, data);
export const deleteActivity = (tripId, activityId) =>
  api.delete(`/trips/${tripId}/activities/${activityId}`);

// Ratings
export const saveRating = (tripId, activityId, data) =>
  api.post(`/trips/${tripId}/activities/${activityId}/ratings`, data);

// Votes
export const voteActivity = (tripId, activityId) =>
  api.post(`/trips/${tripId}/activities/${activityId}/vote`);

// Reactions
export const reactToActivity = (tripId, activityId, emoji) =>
  api.post(`/trips/${tripId}/activities/${activityId}/react`, { emoji });

// Photos
export const getUploadUrl = (tripId, activityId, filename, contentType) =>
  api.post('/photos/upload-url', { tripId, activityId, filename, contentType });

export const uploadToBlob = async (uploadUrl, file) => {
  await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'x-ms-blob-type': 'BlockBlob', 'Content-Type': file.type },
    body: file,
  });
};

// Users
export const getMe = () => api.get('/users/me');
export const updateProfile = (data) => api.put('/users/me', data);

// Export
export const exportTrip = (tripId) => api.get(`/trips/${tripId}/export`);

// Profile Photos
export const getProfileUploadUrl = () => api.post('/photos/profile-upload-url');

// Admin
export const getAdminUsers = () => api.get('/users/admin');
export const deleteAdminUser = (userId) => api.delete(`/users/admin/${userId}`);

// Admin — Entra-integrated user management
export const getAdminEntraUsers = () => api.get('/mgmt/users');
export const removeUserFromTrip = (userId, tripId) => api.post('/mgmt/remove-from-trip', { userId, tripId });
export const deleteUserFully = (userId) => api.delete(`/mgmt/users/${userId}`);
